import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <>
      {/*  ==== footer section start ====  */}
      <footer className="footer pos__rel over__hi">
        <div className="container">
          <div className="footer__area section__space">
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer__intro">
                  <a href="javascript:void(0)">
                    <img
                      src={imageUrl("logo.jpg")}
                      alt="Logo"
                      className="logo"
                    />
                  </a>
                  <p>
                    Web3 Real Estate a platform offering anyone the ability to
                    invest and potentially earn money from property at the click
                    of a button
                  </p>
                  <div className="social">
                    <a href="javascript:void(0)">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href="javascript:void(0)">
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                    <a href="javascript:void(0)">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a href="javascript:void(0)">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer__links footer__links--alt">
                  <h5>Company</h5>
                  <ul>
                    <li>
                      <Link to="/about">About </Link>
                    </li>
                    <li>
                      <Link to="/explore">Explore</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer__links footer__links--alt">
                  <h5>Invest</h5>
                  <ul>
                    <li>
                      <a href="javascript:void(0)">Browse Properties</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">List Your Property</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Rent Property </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer__links footer__links--alt--two">
                  <h5>Insights</h5>
                  <ul>
                    <li>
                      <Link to={"/help"}>Help Center</Link>
                    </li>
                    <li className="neutral-bottom">
                      <Link to="/faq">Faqs</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__credit">
            <div className="row d-flex align-items-center">
              <div className="col-sm-9 order-1 order-sm-0">
                <div className="footer__copyright">
                  <p>Copyright &copy;2023 Web3 Team</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer__animation">
          {/* <img
            // src="assets/images/footer/footer__left__circle.png"
            src={imageUrl("footer/footer__left__circle.png")}
            alt="Circle"
            className="left__circle"
          />
          <img
            // src="assets/images/footer/footer__right__circle.png"
            src={imageUrl("footer/footer__right__circle.png")}
            alt="Circle"
            className="right__circle"
          /> */}
          <img
            src={imageUrl("hero-three-bg.png")}
            alt="Home"
            className="home__illustration"
          />
        </div>
      </footer>
      {/* <!-- ==== #footer section end ==== --> */}
    </>
  );
}

export default Footer;
